import { Link } from 'react-router-dom';

const furtherMaterials = [
  {
    title: 'Тренинг для руководителей',
    desc: 'Практическая программа развития управленческих компетенций: от постановки задач до управления изменениями.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Обучение отдела продаж',
    desc: 'Развитие руководителей и сотрудников отдела продаж. Тренинги по продажам и переговорам для коммерческих команд.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    title: 'Тренинг по переговорам',
    desc: 'Развитие навыков ведения сложных переговоров для руководителей и специалистов.',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
  {
    title: 'Развитие Soft Skills',
    desc: 'Коммуникации, эмоциональный интеллект и другие гибкие навыки для руководителей и сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    title: 'Оценка эффективности обучения',
    desc: 'Как понять, действительно ли обучение изменило поведение сотрудников и результаты бизнеса.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
  },
];

export default function StudyFurtherSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Материалы, которые помогут глубже разобраться в теме корпоративного обучения и выбрать подходящее направление развития.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {furtherMaterials.map((item, i) => (
            <Link
              key={i}
              to={item.to}
              className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 hover:shadow-lg transition-all group cursor-pointer"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{item.desc}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 group-hover:text-teal-700 transition-colors">
                Подробнее
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}